export default "__VITE_ASSET__Bi$dTpdd__"